import { RadioGroup, Stack, Radio } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { DateInterval } from 'types/reporting';

interface DateIntervalSelectProps {
    value: DateInterval;
    onChange: (value: DateInterval) => void;
}

export function DateIntervalSelect({ value, onChange }: DateIntervalSelectProps) {
    return (
        <RadioGroup onChange={(value: DateInterval) => onChange(value)} value={value}>
            <Stack direction="row">
                <Radio value="Yr">
                    <FormattedMessage id="common_annual" defaultMessage="Annual" />
                </Radio>
                <Radio value="Mo">
                    <FormattedMessage id="common_monthly" defaultMessage="Monthly" />
                </Radio>
            </Stack>
        </RadioGroup>
    );
}
